import { MetricTypes } from "../autogen/metrics";

export const INTERNAL_REV_METRIC = MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_PLUS_SHIPPING_PLUS_TAX;
